import React from 'react';
import { isMobile } from 'react-device-detect';
import { useLDClientError, withLDConsumer } from 'launchdarkly-react-client-sdk';
import { Layout, Modal, Header as HeaderModule, FeatureFlags, Toast } from 'common';

import Navigation from 'common/src/code/utils/Navigation';
import ContactsMain from './ContactsMain.component';

const { ModalContainer } = Modal;
const { Header, Analytics } = HeaderModule;
const { LaunchDarklyUtil } = FeatureFlags;
const { RegionType, Viewport, TopPanel } = Layout;
const { withToast } = Toast;

const MainView = () => {
	const layout = {
		[RegionType.North]: {
			height: 50,
		},
		[RegionType.West]: {
			width: 240,
			minWidth: 50,
			maxWidth: 480,
			resizable: true,
			isCollapsed: isMobile === true,
		},
		[RegionType.East]: {
			width: 450,
			minWidth: 50,
			maxWidth: 480,
			resizable: true,
			isCollapsed: isMobile === true,
			isHidden: true,
		},
	};

	const error = useLDClientError();
	if (error) {
		LaunchDarklyUtil.logIntializeError(error);
	}

	const ContactsMainWithLaunchDarkly = withLDConsumer()(withToast(ContactsMain));

	return (
		<Viewport layout={layout}>
			<ModalContainer>
				{/* north region */}
				<TopPanel region={RegionType.North}>
					<Header />
					<Analytics />
				</TopPanel>

				<ContactsMainWithLaunchDarkly />
			</ModalContainer>
		</Viewport>
	);
};

export default MainView;
